export enum FiscalOptionEnumFR {
  AUCUN = 'AUCUN',
  ISF = 'ISF',
  IRPP = 'IRPP',
  APPORT_CESSION = 'APPORT_CESSION',
}

export enum FiscalOptionEnum {
  NONE = 'NONE',
  ISF = 'ISF',
  IRPP = 'IRPP',
  CONTRIBUTION_CESSION = 'CONTRIBUTION_CESSION',
}

export const translateFiscalOption = (fo: FiscalOptionEnumFR): FiscalOptionEnum => {
  switch (fo) {
    case FiscalOptionEnumFR.AUCUN:
      return FiscalOptionEnum.NONE;
    case FiscalOptionEnumFR.ISF:
      return FiscalOptionEnum.ISF;
    case FiscalOptionEnumFR.IRPP:
      return FiscalOptionEnum.IRPP;
    case FiscalOptionEnumFR.APPORT_CESSION:
      return FiscalOptionEnum.CONTRIBUTION_CESSION;
  }
};
